/**
 * Premium
 * No Of Accepted Bid = COMPLETED + IN_TRANSIT
 */

export enum BID_STATUS {
    WAITING = 0,
    NEGOTIATED = 1,
    ACCEPTED = 2, //
    COMPLETED = 3,
    IN_TRANSIT = 4,
    REJECTED = 5,
    EXPIRED = 6,
    CANCELLED = 7,
    STAND_BY = 8,
    PARTIALLY_ACCEPTED = 9,
    UNVERIFIED = 999
}
export enum BID_STATUS_TEXT {
    WAITING = "Waiting",
    REJECTED = "Rejected",
    COMPLETED = "Completed",
    IN_TRANSIT = "In Transit",
    NEGOTIATED = "Negotiated",
    EXPIRED = "Expired",
    CANCELLED = "Cancelled",
    UNVERIFIED = "Unverified",
    ACCEPTED = "Accepted"
}

export const AllBidStatusForCsDashboard = [
    BID_STATUS.WAITING,
    BID_STATUS.NEGOTIATED,
    BID_STATUS.IN_TRANSIT,
    BID_STATUS.STAND_BY,
    BID_STATUS.PARTIALLY_ACCEPTED,
    BID_STATUS.EXPIRED,
    BID_STATUS.COMPLETED,
    BID_STATUS.CANCELLED
];

export const PostAcceptanceBidStatusList = [BID_STATUS.IN_TRANSIT, BID_STATUS.CANCELLED, BID_STATUS.COMPLETED];
